import { render, staticRenderFns } from "./gameadd.vue?vue&type=template&id=07cdf600&scoped=true"
import script from "./gameadd.vue?vue&type=script&lang=js"
export * from "./gameadd.vue?vue&type=script&lang=js"
import style0 from "./gameadd.vue?vue&type=style&index=0&id=07cdf600&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cdf600",
  null
  
)

export default component.exports